// extracted by mini-css-extract-plugin
export default {"button":"app-menu_button__jCe6j"};